<template>
    <div class="default">
        <Header/>
        <Home/>
        <div class="container">
            <Footer/>
        </div>
    </div>
</template>
<script>

import Header from '@/components/UI/header/index.vue'
import Home from '@/views/home/index.vue'
import Footer from '@/components/UI/footer/Footer.vue'
import { defineComponent } from "vue";

export default defineComponent({
  name: 'LxpLayout',
  components: { Header, Footer, Home },
})

</script>

<style lang="scss">
</style>
